var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(("Displayer" + (this.capitalize(this.displayerId))),{tag:"component",staticClass:"livedata-displayer",attrs:{"property-id":_vm.propertyId,"entry":_vm.entry}})}
var staticRenderFns = []

export { render, staticRenderFns }